import {SHOW_LOGS} from '../constants';

class Evented {
  on()      {window.$(this).on     (...arguments);}
  one()     {window.$(this).one    (...arguments);}
  off()     {window.$(this).off    (...arguments);}
  trigger() {
    SHOW_LOGS && console.log('[VOONTO] trigger', ...arguments);
    window.$(this).trigger(...arguments);
  }
}

export default Evented;



// WEBPACK FOOTER //
// ./src/mixins/evented.js